import { isNullOrUndef } from './js/helpers/isNullOrUndef'
import { isNotNullOrUndef } from './js/helpers/isNotNullOrUndef'
import { runAfterWinLoadEvent } from './utils/runAfterWinLoadEvent'

import './styles/basic.scss'
import './styles/oldUsedStyles.scss'

// ICON FONT AND ICON CLASSES
// =============================================================================
import './Icons/icons.scss'

// BACKGROUNDS FOR COLOR ICONS
// =============================================================================
import './styles/backgroundsForColors.scss'

// SECTIONS
// =============================================================================
import './Header/header'
import './Sections/section.promo-bar'

// SNIPPETS
// =============================================================================
import './Snippets/breadcrumbs.scss'

// Events
// =============================================================================
import './events/dataLayerEvents' // GTM dataLayer
import './events/gaEvents' // GA

// Referrals
// =============================================================================
import './esaid/esaid'

// Custom components
// =============================================================================
import './Components/components'

// Accessibility
// =============================================================================
import { a11yAnchors } from './js/a11y'
a11yAnchors()

// Dynamic imports
// =============================================================================
;(function () {
  // Nav
  runAfterWinLoadEvent(() => {
    if (!document.querySelector('.page__login_header__container')) { // if it is nor login/register page
      if (window.matchMedia('(min-width: 1226px)').matches) {
        // Desktop
        import('./nav-desktop/nav.desktop')
      } else {
        // Mobile
        import('./Sidebars/Mobile menu/mobileMenuSidebarNew')
      }
    }
    // Sidebar
    if (
      !window.location.pathname.includes('/login') &&
      !window.location.pathname.includes('/register')
    ) {
      import('./Sidebars/sidebars')
    }
  })
}())

// Basic functions
// =============================================================================
;(function () {
  document.querySelectorAll('a[href="#"]').forEach(elem => {
    elem.addEventListener('click', evt => {
      evt.preventDefault()
    })
  })

  // Back to top
  document.querySelectorAll('[data-action="back-to-top"]').forEach(elem => {
    elem.addEventListener('click', event => {
      event.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
  })
}())

// EVENTS
// =============================================================================
// GTM
;(function (global) {
  const gtm = global.dataLayer = global.dataLayer || []

  // Sign in with form
  document.querySelectorAll('form[action="/account/login"]').forEach(form => {
    form.addEventListener('submit', () => {
      gtm.push({
        event: 'Sign in',
        contact: {
          email: form.querySelector('input[type="email"]').value,
          location: global.location.pathname
        }
      })
    })
  })
}(window))

// Algolia
;(function (global) {
  const Cookies = window.Cookies
  const queryID = Cookies.get('alg_last_queryID') || null
  const index = Cookies.get('alg_last_index') || null

  if (!queryID || !index) return

  Cookies.remove('alg_last_queryID')
  Cookies.remove('alg_last_index')

  document.addEventListener('addToCart', (event) => {
    const sku = ((event.detail || {}).itemData || {}).sku
    if (!sku) {
      return
    }

    const cookieData = Cookies.get('alg_ids_in_cart')
    let arrayIDs = cookieData ? JSON.parse(cookieData) : []

    // delete current sku for update
    arrayIDs = arrayIDs.filter(({ objectID }) => objectID !== sku)

    arrayIDs.push({
      queryID,
      index,
      objectID: sku
    })

    Cookies.set(
      'alg_ids_in_cart',
      JSON.stringify(arrayIDs),
      {
        expires: 1825, // 5 years in days
        sameSite: 'lax'
      }
    )
  })
}(window))

// the event that this file is loaded
// =============================================================================
document.dispatchEvent(new window.CustomEvent('jsThemeLoaded'))

;((global) => {
  global.collectionNewArrivalsBlockAB = () => {
    isNullOrUndef(global.Cookies.get('collectionNewArrivalsBlockAB')) &&
    global.Cookies.set('collectionNewArrivalsBlockAB', '1', { expires: 14 })
  }

  if (isNotNullOrUndef(global.Cookies.get('collectionNewArrivalsBlockAB'))) {
    document.body.classList.add('ab_new-arrivals-block')
  }
})(global)

;((global) => {
  global.promoBarAB = () => {
    isNullOrUndef(global.Cookies.get('promoBarAB')) &&
    global.Cookies.set('promoBarAB', '1', { expires: 14 })
  }
})(window)

;((global) => {
  global.compositeBannerAB = () => {
    isNullOrUndef(global.Cookies.get('compositeBannerAB')) &&
    global.Cookies.set('compositeBannerAB', '1', { expires: 14 })
  }
})(window)
